import React from 'react';
import TextField from '@mui/material/TextField';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
const moment = require('moment');
const InputHtmlRenderer = (props) => {
    const { data } = props;
    const name = data === null || data === void 0 ? void 0 : data.name;
    const label = data === null || data === void 0 ? void 0 : data.label;
    const defaultValue = data === null || data === void 0 ? void 0 : data.defaultValue;
    const required = (data === null || data === void 0 ? void 0 : data.required) ? true : false;
    const color = data === null || data === void 0 ? void 0 : data.color;
    const inputDataChange = props.inputDataChange;
    const multiline = data === null || data === void 0 ? void 0 : data.multiLine;
    const rows = multiline ? 10 : 1;
    const getValidType = (type) => {
        if (!type || type === '') {
            return 'text';
        }
        const lowerCaseType = type.toLowerCase();
        if (lowerCaseType === 'text') {
            return 'text';
        }
        else if (lowerCaseType === 'email') {
            return 'email';
        }
        else if (lowerCaseType === 'phone') {
            return 'tel';
        }
        else if (lowerCaseType === 'date') {
            return 'date';
        }
        else if (lowerCaseType === 'float') {
            return 'number';
        }
        else if (lowerCaseType === 'int') {
            return 'number';
        }
        else if (lowerCaseType === 'number') {
            return 'number';
        }
        return 'text';
    };
    const type = getValidType(data === null || data === void 0 ? void 0 : data.type);
    const isDateField = (type === 'date') ? true : false;
    const date_to_string = (date) => {
        return moment(date).format('YYYY-MM-DD');
    };
    return (React.createElement(React.Fragment, null, isDateField ? (React.createElement(LocalizationProvider, { dateAdapter: AdapterDateFns },
        React.createElement(DatePicker, { label: label, onChange: (date) => inputDataChange({ target: { id: name, value: date_to_string(date) } }), slotProps: { textField: { required: true } } }))) : (React.createElement("div", null,
        React.createElement(TextField, { className: 'form-input', fullWidth: true, required: required, rows: rows, id: name, label: label, defaultValue: defaultValue, onChange: inputDataChange, color: "primary", multiline: multiline, type: type })))));
};
export default InputHtmlRenderer;
//# sourceMappingURL=InputHtmlRenderer.js.map